import { render, staticRenderFns } from "./FreezerInformation.vue?vue&type=template&id=73c0e19e&"
import script from "./FreezerInformation.vue?vue&type=script&lang=js&"
export * from "./FreezerInformation.vue?vue&type=script&lang=js&"
import style0 from "./FreezerInformation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports